import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, "Personal", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle1" }, "File", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_PhoneInput = _resolveComponent("PhoneInput")!
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_separator),
    _createVNode(_component_q_input, {
      label: "First Name",
      "model-value": _ctx.firstName,
      outlined: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:firstName', $event)))
    }, null, 8, ["model-value"]),
    _createVNode(_component_q_input, {
      label: "Last Name",
      "model-value": _ctx.lastName,
      outlined: "",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:lastName', $event)))
    }, null, 8, ["model-value"]),
    _createVNode(_component_q_input, {
      label: "Email",
      "model-value": _ctx.email,
      outlined: "",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:email', $event)))
    }, null, 8, ["model-value"]),
    _createVNode(_component_PhoneInput, {
      label: "Phone",
      "model-value": _ctx.phone,
      outlined: "",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:phone', $event))),
      required: ""
    }, null, 8, ["model-value"]),
    _createVNode(_component_date_picker, {
      label: "Date of Birth",
      "model-value": _ctx.dateOfBirth,
      "max-date": _ctx.now,
      outlined: "",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:dateOfBirth', $event)))
    }, null, 8, ["model-value", "max-date"]),
    _hoisted_3,
    _createVNode(_component_q_separator),
    _createVNode(_component_q_input, {
      label: "File Reference Number (Optional)",
      "model-value": _ctx.fileRefNo,
      outlined: "",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:fileRefNo', $event)))
    }, null, 8, ["model-value"]),
    _createVNode(_component_date_picker, {
      label: "Date of Loss",
      "model-value": _ctx.dateOfLoss,
      "min-date": _ctx.dateOfBirth,
      "max-date": _ctx.now,
      outlined: "",
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:dateOfLoss', $event)))
    }, null, 8, ["model-value", "min-date", "max-date"])
  ]))
}